import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary:    { main: '#4f46e5', light: '#818cf8', dark: '#3730a3' },
    secondary:  { main: '#f59e0b' },
    background: { default: '#f1f5f9', paper: '#ffffff' },
    success:    { main: '#10b981' },
    error:      { main: '#ef4444' },
    warning:    { main: '#f59e0b' },
    text:       { primary: '#0f172a', secondary: '#64748b' },
    divider:    'rgba(15,23,42,0.1)',
  },
  typography: {
    fontFamily: "'DM Sans', sans-serif",
    h1: { fontFamily: "'Sora', sans-serif" },
    h2: { fontFamily: "'Sora', sans-serif" },
    h3: { fontFamily: "'Sora', sans-serif" },
    h4: { fontFamily: "'Sora', sans-serif" },
    h5: { fontFamily: "'Sora', sans-serif" },
    h6: { fontFamily: "'Sora', sans-serif" },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(15,23,42,0.08)',
          boxShadow: '0 1px 4px rgba(15,23,42,0.06)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, borderRadius: 8 },
        containedPrimary: {
          background: 'linear-gradient(135deg,#4f46e5,#6366f1)',
          boxShadow: '0 2px 8px rgba(79,70,229,0.3)',
          '&:hover': { background: 'linear-gradient(135deg,#3730a3,#4f46e5)' },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            backgroundColor: '#f8fafc',
          },
          // Ensure label never gets clipped — add top margin so label floats clear
          '& .MuiInputLabel-outlined': {
            '&.MuiInputLabel-shrink': { transform: 'translate(14px, -9px) scale(0.75)' },
          },
        },
      },
    },
    // DialogContent: always has padding-top so labels aren't clipped by dialog edge
    MuiDialogContent: {
      styleOverrides: {
        root: {
          paddingTop: '20px !important',
          paddingLeft: 24,
          paddingRight: 24,
          paddingBottom: 16,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-root': {
            background: '#f8fafc',
            fontWeight: 700,
            fontSize: '0.72rem',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            color: '#64748b',
            borderBottom: '2px solid rgba(79,70,229,0.15)',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: { root: { borderColor: 'rgba(15,23,42,0.06)' } },
    },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: '#ffffff',
          borderRight: '1px solid rgba(15,23,42,0.08)',
          boxShadow: '2px 0 12px rgba(15,23,42,0.06)',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          boxShadow: '0 20px 60px rgba(15,23,42,0.15)',
          border: '1px solid rgba(15,23,42,0.08)',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, fontSize: '0.875rem' },
      },
    },
  },
});
